var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('span',[_vm._v("Restoku Dashboard "+_vm._s(_vm.title))]),_vm._v(" "),(_vm.isLogin)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_c('img',{attrs:{"src":"https://img.icons8.com/windows/32/FFFFFF/logout-rounded.png"}})]):_vm._e()]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fcaf229","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 167
// module chunks = 1